import { components } from '@api/play-account/generated';

import { ChartPoint, ClockControlType } from '@features/shared/api/typings';
import { TIME_CONTROL } from '@features/shared/constants';
import { usePlayerEloHistoryQuery } from '@features/user/api/hooks';
import { PlayerEloStatPreview } from '@features/user/ui/PlayerEloStatsPreview/PlayerEloStatPreview/PlayerEloStatPreview';

type Props = {
  userId?: string;
  clockControlType: ClockControlType;
  showBorder?: boolean;
};
export function PlayerEloStatPreviewWidget({ userId, showBorder, clockControlType }: Props) {
  const { data: eloHistory } = usePlayerEloHistoryQuery({
    periodType: 'Daily',
    periodsCount: 7,
    clockControlType,
    userId,
  });

  const points = convertEloHistoryToChartPoints(eloHistory);

  const delta = (eloHistory && eloHistory.endElo - eloHistory.startElo) || 0;

  return (
    <PlayerEloStatPreview
      title={TIME_CONTROL[clockControlType]}
      rank={eloHistory?.endElo}
      gameCount={eloHistory?.gamesCount}
      points={points}
      delta={delta}
      showBorder={showBorder}
    />
  );
}

function convertEloHistoryToChartPoints(
  eloHistory?: components['schemas']['UserEloHistoryDto'],
): ChartPoint[] | undefined {
  if (!eloHistory) return;
  return eloHistory.periods.map((p) => ({
    x: p.startDateTimestampMs,
    y: p.startElo,
    label: p.delta,
  }));
}
